import { render, staticRenderFns } from "./BranchHotGoods.vue?vue&type=template&id=5724f44f"
import script from "./BranchHotGoods.vue?vue&type=script&lang=js"
export * from "./BranchHotGoods.vue?vue&type=script&lang=js"
import style0 from "./BranchHotGoods.vue?vue&type=style&index=0&id=5724f44f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports